var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-date-picker',_vm._g(_vm._b({attrs:{"type":_vm.type,"value-format":_vm.$attrs.valueFormat || _vm.$attrs['value-format'] || 'yyyy-MM-dd',"picker-options":_vm.pickerOption}},'el-date-picker',_vm.$attrs,false),_vm.$listeners))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }